import React from 'react';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

import { SimTypography } from 'components/SimTypography';
import SimFeaturedEventsSlider from 'components/SimFeaturedEventsSlider';

const SliderALLParentEdServices = () => {
	const theme = useTheme();

	return (
		<Box>
			<Box marginBottom={4}>
				<SimTypography
					sx={{
						textTransform: 'uppercase',
						fontWeight: 'medium'
					}}
					gutterBottom
					color={theme.palette.secondary.mainGreen}
					align={'center'}>
					Featured Events & Sessions
				</SimTypography>
				<SimTypography
					variant='h4'
					align={'center'}
					data-aos={'fade-up'}
					gutterBottom
					sx={{
						fontWeight: 700
					}}>
					Browse our upcoming events & sessions
				</SimTypography>
				<SimTypography variant='h6' align={'center'} color={'text.secondary'} data-aos={'fade-up'}>
					We bring together families who feel lonely & helpless in this journey
				</SimTypography>
				<Box
					display='flex'
					flexDirection={{ xs: 'column', sm: 'row' }}
					alignItems={{ xs: 'stretched', sm: 'flex-start' }}
					justifyContent={'center'}
					marginTop={2}></Box>
			</Box>

			<SimFeaturedEventsSlider />
		</Box>
	);
};

export { SliderALLParentEdServices };
